import { useEffect, useState } from 'react';

import { EnterpriseBlockStyled } from '../EnterpriseDetails/enterprise-block.styled';
import EnterpriseFormFooter from '../EnterpriseFormFooter';
import Jpaper from '@atoms/JPaper';
import VideoUpload from '@atoms/VideoUpload';
import useCreateEnterprise from '@enterprise/hooks/useCreateEnterprise';

interface EnterpriseFormVideoProps {
  includeFooter: boolean;
}
const EnterpriseFormVideo = ({ includeFooter }: EnterpriseFormVideoProps) => {
  const { payload, setPayload, setIsDirty } = useCreateEnterprise();
  const [video, setVideo] = useState<File | undefined>(payload?.video);
  const [thumbnail, setThumbnail] = useState<File | undefined>(
    payload?.thumbnail,
  );

  useEffect(() => {
    setPayload((prev) => {
      return {
        ...prev,
        video,
      };
    });
    setIsDirty(true);
  }, [video, setPayload, setIsDirty]);

  useEffect(() => {
    setPayload((prev) => {
      return {
        ...prev,
        thumbnail,
      };
    });
    setIsDirty(true);
  }, [thumbnail, setPayload, setIsDirty]);

  const onVideoDelete = () => {
    setVideo(undefined);
    setThumbnail(undefined);
    setPayload((prev) => {
      return {
        ...prev,
        video: undefined,
        videoUrl: undefined,
        thumbnail: undefined,
        thumbnailUrl: undefined,
      };
    });
  };
  return (
    <>
      <EnterpriseBlockStyled>
        <Jpaper gap={1} alignItems="stretch" attr={{ fullHeight: true }}>
          <VideoUpload
            data-qa="video-upload"
            urlVideoValue={payload?.videoUrl}
            urlThumbnailValue={payload?.thumbnailUrl}
            value={payload?.video}
            onVideoUpload={(value) => {
              setVideo(value);
            }}
            onThumbnailUpload={(value) => setThumbnail(value)}
            onVideoDelete={onVideoDelete}
          />
        </Jpaper>
      </EnterpriseBlockStyled>
      {includeFooter && (
        <EnterpriseFormFooter
          submitTab
          isValid={
            !!(payload?.videoUrl && payload.thumbnailUrl) ||
            !!(video && thumbnail)
          }
          values={{ video, thumbnail }}
        />
      )}
    </>
  );
};

export default EnterpriseFormVideo;
